module.exports = __webpack_public_path__ + "img/game-sdk.33f723e.png";